module.exports = __webpack_public_path__ + "img/APRILIA.a7ac6f3.jpg";